import * as InformacionesDTOs from "./InformacionesDTOs.js";
import * as TipoObjeto from "../../constantes/TipoObjeto.js";

export const ItemVacio = (idPadre) => {
  return InformacionesDTOs.ItemVacio(TipoObjeto.PERSONA, idPadre);
};

export const saveItem = (item) => {
  return InformacionesDTOs.saveItem(item);
};
